<template>
    <div class="app">
        <div class="content">
            <router-view />
        </div>
        <MobileFooter v-if="isMobileDevice" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "./plugins/LanguageComponent";
import { loadLocaleMessages } from "./plugins/LanguageComponent";
import detectDeviceMixin from "@/mixins/detectDeviceMixin";
import MobileFooter from "@/components/layout/MobileFooter.vue";

export default {
    name: "App",
    mixins: [detectDeviceMixin],
    components: {
        MobileFooter,
    },
    data() {
        return {
            isMobileView: false,
        };
    },
    computed: {
        ...mapGetters("language", ["currentLanguage"]),
    },
    watch: {
        currentLanguage(newLang) {
            if (newLang !== i18n.global.locale.value) {
                loadLocaleMessages(newLang);
            }
        },
        isMobileDevice(newVal) {
            this.isMobileView = newVal;
        },
    },
    async mounted() {
        this.isMobileView = this.isMobileDevice;
        if (this.$route.path.includes("confirm-reservation")) {
            this.isMobileDevice = false;
        }

        const savedLanguage = i18n.global.locale.value || "en";
        console.log(`App mounted with language: ${savedLanguage}`);
        await loadLocaleMessages(savedLanguage);
        i18n.global.locale.value = savedLanguage;
    },
};
</script>

<style scoped>
.app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

/* Tambahkan margin-bottom hanya untuk mobile */
@media (max-width: 768px) {
    .content {
        margin-bottom: 40px; /* Sesuaikan dengan tinggi footer */
    }
}
</style>
